import {apiClient, getHeader, getOrganizationId, handleError, handleResponse} from '@/helpers/api'
import WhitelabelFileTypes from '@/enums/WhitelabelFileTypes'

// EXPORTS
export const whitelabelService = {
  getURLs,
  getCSS,
  getEmailHTML,
  getFonts,
  getFontsCSS,
  getThemeColors,
  getLogo,
  getFavicon,
  putURLs,
  putCSS,
  putFont,
  resetFonts,
  putFile,
  putThemeColors,
  putEmailHTML
}

// API CALLS
export function getURLs() {
  if(!getOrganizationId()) {
    return
  }
  return apiClient
  .get(`/whitelabel/${getOrganizationId()}/general-information`)
  .then(handleResponse)
  .catch(handleError)
}

export function getCSS(subdomain) {
  return apiClient
  .get(`/whitelabel/${subdomain}/css`,
    getHeader())
  .then(handleResponse)
  .catch(handleError)
}

export function getEmailHTML() {
  return apiClient
  .get(`/whitelabel/${getOrganizationId()}/email-footer`)
  .then(handleResponse)
  .catch(handleError)
}

export function getFonts() {
  return apiClient
  .get(`/whitelabel/${getOrganizationId()}/fonts`)
  .then(handleResponse)
  .catch(handleError)
}

export function getFontsCSS(subdomain) {
  return apiClient
  .get(`/whitelabel/${subdomain}/fonts-css`)
  .then(handleResponse)
  .catch(handleError)
}

export function getThemeColors(subdomain) {
  return apiClient
  .get(`/whitelabel/${subdomain}/theme-colors`)
  .then(handleResponse)
  .catch(handleError)
}

export function getLogo(subdomain, type = 5) {
  return apiClient
  .get(`/whitelabel/${subdomain}/logos/${type}`, { responseType: 'arraybuffer' })
  .then((response) => {
    if(response.status !== 200) {
      return
    }
    return response.data
  })
  // .then(handleResponse)
  .catch(handleError)
}

export function getFavicon(subdomain) {
  return apiClient
  .get(`/whitelabel/${subdomain}/favicon`, { responseType: 'arraybuffer' })
  .then(handleResponse)
  .catch(handleError)
}

export function putURLs(urls) {
  return apiClient
  .put(`/whitelabel/${getOrganizationId()}/general-information`,
    urls,
    getHeader())
  .then(handleResponse)
  .catch(handleError)
}

export function putCSS(css) {
  return apiClient
  .put(`/whitelabel/${getOrganizationId()}/css`,
    css,
    getHeader())
  .then(handleResponse)
  .catch(handleError)
}

export function putFont(font) {
  return apiClient
  .put(`/whitelabel/${getOrganizationId()}/fonts`,font)
  .then(handleResponse)
  .catch(handleError)
}

export function resetFonts() {
  return apiClient
  .delete(`/whitelabel/${getOrganizationId()}/fonts/reset-default?fileType=${WhitelabelFileTypes.Font}`, {})
  .then(handleResponse)
  .catch(handleError)
}

export function putFile(file, type) {
  const formData = new FormData()
  formData.append('file', file)
  formData.append('type', type)

  return apiClient
  .put(`/whitelabel/${getOrganizationId()}/file`,formData)
  .then(handleResponse)
  .catch(handleError)
}

export function putThemeColors(colors) {
  return apiClient
  .put(`/whitelabel/${getOrganizationId()}/theme-colors`,
    colors,
    getHeader({
      'Content-Type': 'text/plain'
    }))
  .then(handleResponse)
  .catch(handleError)
}

export function putEmailHTML(emailHtml) {
  return apiClient
  .put(`/whitelabel/${getOrganizationId()}/email-footer`,
    emailHtml,
    getHeader())
  .then(handleResponse)
  .catch(handleError)
}
